import React from 'react';
import './style.scss';

const Loader = () => {
  return (
    <div className="custom-loader">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  )
}

export default Loader;
